module.exports = __webpack_public_path__ + "img/icon-wallet.4ec8b336.svg";